import frenchMessages from 'ra-language-french';
import englishMessages from 'ra-language-english';
import { raPreferencesLanguageFrench } from '@react-admin/ra-preferences';
import { raPreferencesLanguageEnglish } from '@react-admin/ra-preferences';
import { bpmnEn, bpmnFr } from './bpmn';
import { mergeDeep } from '@apollo/client/utilities';
import en from "./en";
import fr from "./fr";
import enExtends from "./extends/enExtends";
import frExtends from "./extends/frExtends";
import importEn from "react-admin-import-csv/src/i18n/en";
import importFr from "react-admin-import-csv/src/i18n/fr";

const frRA = mergeDeep(frenchMessages, raPreferencesLanguageFrench, frExtends);
const enRA = mergeDeep(englishMessages, raPreferencesLanguageEnglish, enExtends);

const messages = {
    fr: { ...frRA, ...bpmnFr, ...importFr, ...fr },
    en: { ...enRA, ...bpmnEn, ...importEn, ...en }
};

export default messages;